import { render } from "./workflow-review.vue?vue&type=template&id=fe3546e5&scoped=true"
import script from "./workflow-review.vue?vue&type=script&lang=js"
export * from "./workflow-review.vue?vue&type=script&lang=js"

import "./workflow-review.vue?vue&type=style&index=0&id=fe3546e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3546e5"]])

export default __exports__